import { browser } from '$app/environment';
import { cfgOptimoveEnabled } from '@infinitro/config';
export const OPTIMOVE_EVENTS = {
    REGISTRATION: 'registration',
    LOGIN: 'login'
};
const getOptimoveApi = () => {
    if (!browser || !cfgOptimoveEnabled())
        return undefined;
    const sdk = globalThis.optimoveSDK;
    if (!sdk || typeof sdk !== 'object' || !sdk.API)
        return undefined;
    return sdk.API;
};
const buildEventContext = (extra) => {
    const context = {};
    if (!extra)
        return context;
    for (const [key, value] of Object.entries(extra)) {
        if (value !== undefined) {
            context[key] = value;
        }
    }
    return context;
};
export const setOptimoveUserId = (playerId) => {
    const api = getOptimoveApi();
    if (!api)
        return;
    try {
        api.setUserId(playerId);
    }
    catch (error) {
        console.log(`optimove setUserId failed: ${error}`);
    }
};
export const trackOptimovePageVisit = (url, title, category) => {
    const api = getOptimoveApi();
    if (!api)
        return;
    try {
        api.setPageVisit(url, title, category);
    }
    catch (error) {
        console.log(`optimove setPageVisit failed: ${error}`);
    }
};
export const trackOptimoveLogin = (playerId, context) => {
    const api = getOptimoveApi();
    if (!playerId || !api)
        return;
    try {
        setOptimoveUserId(playerId);
        api.reportEvent(OPTIMOVE_EVENTS.LOGIN, buildEventContext(context), null, playerId);
    }
    catch (error) {
        console.log(`optimove login event failed: ${error}`);
    }
};
export const trackOptimoveRegistration = (playerId, email, context) => {
    const api = getOptimoveApi();
    if (!playerId || !api)
        return;
    try {
        setOptimoveUserId(playerId);
        api.reportEvent(OPTIMOVE_EVENTS.REGISTRATION, buildEventContext({ ...context, ...(email ? { email } : {}) }), null, playerId);
    }
    catch (error) {
        console.log(`optimove registration event failed: ${error}`);
    }
};
